import { loginNameSpace } from "&features/login/login.i18n";

let ar = {
  login: loginNameSpace.ar,
};

export default ar;
